import clsx from "clsx";
import React from "react";
import styles from "./styles.module.scss";

export interface SelectProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  error?: boolean;
}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, error = false, ...props }, ref) => {
    return (
      <select
  className={clsx(styles._onetouchai_select, error && styles._onetouchai_destructive, className)}
        ref={ref}
        {...props}
      />
    );
  }
);
Select.displayName = "Select";

export { Select };
